export function homepagesQuery() {
	return {
		fields: ['*',
			{
				blocks: allBlocks()
			}
		],
	}
}

export function itemSEOQuery(status = 'published') {
	return {
		fields: ['slug', 'date_created', 'date_updated', 'seo'],
		filter: {
			'status': {
				'_eq': status
			}
		},
	}
}

export function pageQuery(slug, status = 'published') {
	return {
		fields: ['*',
			{
				blocks: allBlocks()
			}
		],
		filter: {
			'slug': {
				'_eq': slug
			},
			'status': {
				'_eq': status
			}
		},
	}
}

export function singleWorkQuery(slug, status = 'published') {
	return {
		fields: ['*',
			{
				featured_image: image(),
				categories: [
					{
						category: ['id', 'title', 'url']
					}
				],
				blocks: allBlocks(),
			}
		],
		filter: {
			'slug': {
				'_eq': slug
			},
			'status': {
				'_eq': status
			}
		},
	}
}


export function allWorksQuery(status = 'published') {
	return {
		fields: ['*',
			{
				blocks: allBlocks(),
				featured_image: image(),
				thumbnail_image: image(),
				thumbnail_video: video(),
				categories: [
					{
						category: ['id', 'title', 'url']
					}
				],
			},
		],
		filter: {
			'status': {
				'_eq': status
			}
		},
	}
}

export function allWorksLiteQuery(status = 'published') {
	return {
		fields: ['*',
			{
				featured_image: image(),
				thumbnail_image: image(),
				thumbnail_video: video()
			}
		],
		filter: {
			'status': {
				'_eq': status
			}
		},
	}
}

export function menuQuery() {
	return {
		fields: ['*',
			{
				menu_items: ['item', 'collection']
			}
		],
	}
}

export function menuItemQuery() {
	return {
		fields: ['*'],
	}
}

export function footerQuery() {
	return {
		fields: ['*',
			{
				menu_column_left: ['menus_id'],
				menu_column_right: ['menus_id']
			}
		],
	}
}
